import PropTypes from 'prop-types'

export default function H5TitleLeftAlign({title, className, ...props}) {
  return (
    <h5 className={`text-left ${className ? className : ''}`} {...props}>{title}</h5>
  )
}

H5TitleLeftAlign.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string
}